import { Injectable } from "@angular/core";
import { SubtitleRepository } from "../../../domain/subtitle-repository";
import { HttpService } from "../../http/http";

@Injectable()
export class SubtitleRepositoryImpl implements SubtitleRepository {
  constructor(private httpService: HttpService) {}

  /**
   * Downloading Subtitle Content
   * @param url
   * @return
   */
  downloadSubtitle(url: string) {
    var options = this.httpService.createDefaultNonAuthRequestOption();

    return this.httpService.getJSON(url, options);
  }

  /**
   * Query server for subtitle URL (temporary URL)
   * @param subtitleId
   * @return Promise
   */
  getSubtitleURL(subtitleId: number) {
    return this.httpService.get(`Subtitle/getUrl/${subtitleId}`);
  }

  /**
   * Query server for a closed caption's original content URL (temporary URL)
   * @param subtitleId
   * @return Promise
   */
  getClosedCaptionOriginalURL(subtitleId: number) {
    return this.httpService.get(`Subtitle/getOriginalUrl/${subtitleId}`);
  }
}
